import { render, staticRenderFns } from "./Disbursement.vue?vue&type=template&id=20716b85&scoped=true"
import script from "./Disbursement.vue?vue&type=script&lang=js"
export * from "./Disbursement.vue?vue&type=script&lang=js"
import style0 from "./Disbursement.vue?vue&type=style&index=0&id=20716b85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20716b85",
  null
  
)

export default component.exports